import { Stack } from "@mui/material";
import { Timestamp } from "firebase/firestore";
import { FormButton } from "../../components/buttons/FormButton";
import { sUpdate } from "../../constants/strings";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { formHooks } from "../../hooks/handlers/useFormHandler";
import useForm from "../../hooks/useForm";
import { RenderForm } from "../../utils/formUtils";
import { AutofillForm } from "../../utils/helpers";

export const FormLayoutHandler = ({
  source,
  id,
  setOpen,
  data,
  loading: externalLoading,
}) => {
  const { form, onChange, updateFormValues, clearForm, setForm } = useForm();
  const { loading, updateData, addData } = useFirebase();

  // get source hooks
  const { fields, api } =
    (formHooks[source] && formHooks[source]({ form, updateFormValues })) || {};

  AutofillForm(data, setForm);

  function handleUpdate() {
    const docRef = form?.docRef;
    if (docRef) updateData(docRef, form).then(() => setOpen?.(false));
  }

  function onSubmit(e) {
    e.preventDefault();

    if (data) {
      handleUpdate();
    } else {
      // add timestamp
      form.timestamp = Timestamp.now();
      addData(api, form, clearForm);
    }
  }

  return (
    <div>
      <form onSubmit={onSubmit}>
        <div>
          <Stack spacing={3}>
            <RenderForm {...{ form, onChange, fields, updateFormValues }} />
            <FormButton loading={loading || externalLoading}>
              {data ? sUpdate : "Submit"}
            </FormButton>
            {/* <div onClick={clearForm}>Clear</div> */}
          </Stack>
        </div>
      </form>
    </div>
  );
};
